import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SchoolIcon from "@mui/icons-material/School";
import { useNavigate } from "react-router-dom";
import { Box, Button, IconButton, Modal, Slide } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Lottie from "lottie-react";
import tickAnimation from "../../assets/tick.json";
import { scheduleMeeting } from "../api";
import {
    CITLink,
    FeatureCardBody,
    FeatureCardHeading,
    FeatureCardImage,
    FeatureCardNextButton,
    FeatureCardP,
    FeatureCardWrapper,
    Features,
    Header,
    Heading,
    MeetInput,
    PoweredBy,
    SubHeading,
    Wrapper,
} from "../ChatMeetWidget/styles";

const Index = ({
    chatLink = "",
    logo = "",
    headerBg = "",
    welcomeMsg = "Welcome to CollegeIt's widget",
    logoStyles = { width: "210px", transform: "translateX(-10px)" },
    university = "boston",
    headingStyle = {},
    subheadingStyle = {},
}) => {
    const navigate = useNavigate();
    const [showForm, setShowForm] = React.useState(false);
    const [showSuccess, setShowSuccess] = React.useState(false);

    const onFormSubmit = async (data) => {
        const res = await scheduleMeeting({
            ...data,
            university,
        });

        console.log(res);

        if (res?.ok) {
            setShowSuccess(true);
            setTimeout(() => {
                setShowSuccess(false);
            }, 12000);
        } else {
            alert("Something went wrong. Please try again.");
        }
    };

    const headerStyle = headerBg ? { backgroundColor: headerBg } : {};

    return (
        <Wrapper style={{ minHeight: "100vh" }}>
            <Header style={headerStyle}>
                <img src={logo} alt="Loyla Logo" style={logoStyles} />
                <Heading style={headingStyle}>{welcomeMsg}</Heading>
                <SubHeading style={subheadingStyle}>
                    Have a question?
                </SubHeading>
            </Header>
            {!showForm ? (
                <Features>
                    <FeatureCard
                        img={"/loyla-chat.png"}
                        heading={"Chat with us"}
                        onClick={() => navigate(chatLink)}
                        paragraph={
                            "Speak to a current student, alum, or faculty advisor on WhatsApp. "
                        }
                    />
                    <FeatureCard
                        img={"/loyla-zoomcall.png"}
                        heading={"Schedule a Zoom call"}
                        onClick={() => setShowForm(true)}
                        paragraph={
                            "Join a Zoom meeting with our admissions team. "
                        }
                    />
                    <PoweredBy>
                        Powered By
                        <CITLink
                            href="https://collegeit.org"
                            target="_blank"
                            rel="no-referer"
                        >
                            <SchoolIcon
                                style={{ fontSize: "20px", marginRight: "3px" }}
                            />
                            CollegeIt
                        </CITLink>
                    </PoweredBy>
                </Features>
            ) : (
                <Wrapper>
                    <ZoomForm
                        goBack={() => setShowForm(false)}
                        onFormSubmit={onFormSubmit}
                    />
                </Wrapper>
            )}
            <Modal
                open={showSuccess}
                onClose={() => setShowSuccess(false)}
                closeAfterTransition
            >
                <Slide direction="up" in={showSuccess}>
                    <Box
                        style={{
                            height: "100%",
                            width: "100%",
                            background: "white",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "start",
                            paddingTop: "120px",
                            position: "relative",
                        }}
                    >
                        <SuccessMessage close={() => setShowSuccess(false)} />
                    </Box>
                </Slide>
            </Modal>
        </Wrapper>
    );
};

const SuccessMessage = ({ close }) => {
    return (
        <>
            <IconButton
                onClick={close}
                style={{ position: "absolute", top: "0", left: "0" }}
            >
                <ArrowBackIcon />
            </IconButton>
            <h1
                style={{
                    width: "80%",
                    fontFamily: "Outfit",
                    fontSize: "23px",
                    textAlign: "center",
                    paddingBottom: "20px",
                }}
            >
                Your meeting request has been submitted successfully!
            </h1>
            <Lottie
                {...{
                    loop: false,
                    autoplay: true,
                    animationData: tickAnimation,
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice",
                    },
                }}
                height={100}
                width={100}
            />
            <span
                style={{
                    paddingTop: "28px",
                    fontFamily: "Outfit",
                    textAlign: "center",
                    color: "gray",
                    fontSize: "20px",
                    width: "80%",
                }}
            >
                We will reach out to you shortly.
            </span>
        </>
    );
};

const FeatureCard = ({ img, heading, paragraph, onClick = () => {} }) => {
    return (
        <FeatureCardWrapper onClick={onClick} dontHover>
            <FeatureCardImage src={img} alt="Chat Icon" />
            <FeatureCardBody>
                <FeatureCardHeading>{heading}</FeatureCardHeading>
                <FeatureCardP>{paragraph}</FeatureCardP>
            </FeatureCardBody>
            <FeatureCardNextButton>
                <ArrowForwardIcon />
            </FeatureCardNextButton>
        </FeatureCardWrapper>
    );
};

const ZoomForm = ({ goBack, onFormSubmit }) => {
    const [email, setEmail] = React.useState("");
    const [country, setCountry] = React.useState("");

    const handleNameChange = (e) => {
        setEmail(e.target.value);
    };

    const handleCountryChange = (e) => {
        setCountry(e.target.value);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        await onFormSubmit({ email, country });
        console.log("Submitted");
    };

    return (
        <FeatureCardWrapper
            style={{
                marginTop: "30px",
                width: "90%",
                boxSizing: "border-box",
                flexDirection: "column",
                scale: "1",
                padding: "18px 26px",
            }}
        >
            <FeatureCardHeading style={{ fontSize: "20px" }}>
                Schedule a meeting
            </FeatureCardHeading>
            <FeatureCardP
                style={{
                    fontSize: "14px",
                    marginBottom: "12px",
                    lineHeight: "1.2",
                }}
            >
                Please provide the following details. Our team will contact you
                shortly.{" "}
            </FeatureCardP>
            <form onSubmit={onSubmit}>
                <MeetInput
                    value={email}
                    onChange={handleNameChange}
                    placeholder="Email address*"
                    type="email"
                    style={{ marginTop: "8px" }}
                    required
                />
                <MeetInput
                    value={country}
                    onChange={handleCountryChange}
                    placeholder="Country*"
                    type="text"
                    style={{ marginTop: "14px", marginBottom: "14px" }}
                    required
                />
                <div style={{ display: "flex", gap: "12px" }}>
                    <Button
                        style={{
                            textTransform: "none",
                            padding: "1px 9px",
                            fontFamily: "Outfit",
                            color: "gray",
                            borderColor: "gray",
                            fontWeight: "400",
                        }}
                        onClick={goBack}
                        variant="outlined"
                    >
                        Go Back
                    </Button>
                    <Button
                        style={{
                            textTransform: "none",
                            padding: "1px 9px",
                            fontFamily: "Outfit",
                            backgroundColor: "#2E8EFF",
                            fontWeight: "400",
                        }}
                        variant="contained"
                        type="submit"
                    >
                        Request Meeting
                    </Button>
                </div>
            </form>
        </FeatureCardWrapper>
    );
};

export default Index;
